module.exports = {
    STATUS: {id: 'STATUS', name: 'статус'},
    PAYMENT: {id: 'PAYMENT', name: 'оплата'},
    FISC: {id: 'FISC', name: 'фіскалізація'},
    CASHIN: {id: 'CASHIN', name: 'внесення готівки'},
    CASHOUT: {id: 'CASHOUT', name: 'виведення готівки'},
    OPENSHIFT: {id: 'OPENSHIFT', name: 'відкриття зміни'},
    XREPORT: {id: 'XREPORT', name: 'x-звіт PDF'},
    ZREPORT: {id: 'ZREPORT', name: 'закриття зміни'},
    GETRECPDF: {id: 'GETRECPDF', name: 'чек PDF'},
    GETZREPPDF: {id: 'GETZREPPDF', name: 'z-звіт PDF'},
  };